import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import CatalogNodePathSelectionModal from "@common/components/MultiLevelNavigation/CatalogNodePathSelectionModal.vue";
import PathPresenter from "@common/components/PathPresenter.vue";
import { useContentLanguages } from "@common/composable/useMetaDataStore";
import { CatalogNodePath } from "@medapro-types/ContentEditor/content-editor-store";
import { Branch, MultiLevelNavigationConfirmModel } from "@medapro-types/common/components/MultiLevelNavigation";
import { PathPresentedDataModel } from "@medapro-types/common/components/PathPresenter";
import catalogNodesApi from "@services/catalogNodes.js";
import _ from "lodash";
import { computed, nextTick, onMounted, reactive } from "vue";

//#region General
type ViewModel = { selectedPath: PathPresentedDataModel[] };

export default /*#__PURE__*/_defineComponent({
  __name: 'CatalogPathRule',
  props: {
    value: {}
  },
  emits: ["input", "deleteRule"],
  setup(__props: any, { emit: emits }) {

const props = __props;



//#endregion

//#region Store
const { primaryLanguageCode } = useContentLanguages();
//#endregion

//#region Viewmodel
const vm = reactive<ViewModel>({ selectedPath: [] });

const modals = reactive({ open: false });
//#endregion

const localModel = computed({
  get() {
    return props.value;
  },
  set(nv) {
    emits("input", nv);
  }
});
//#endregion

//#region SelectedPath
const selectedPath = computed<Branch[]>(() =>
  vm.selectedPath?.filter((x) => x.id != localModel.value).map((x, index) => ({ id: x.id, depth: index, name: x.name, parentId: null }))
);
//#endregion

//#region EventHandler
const onHideHandler = () => {
  nextTick(() => {
    if (_.isEmpty(localModel.value)) emits("deleteRule");
  });
};

const onConfirm = async (data: MultiLevelNavigationConfirmModel) => {
  if (data.selection && data.selection.id) {
    localModel.value = data.selection.id;
    fetchAndSetPath(data.selection.id);
  }
};

const fetchAndSetPath = async (id: string) => {
  const fetchedPath: CatalogNodePath = await catalogNodesApi.getCatalogNodePathInBaseCatalog(id, primaryLanguageCode.value);
  const mappedPath: PathPresentedDataModel[] = fetchedPath.map((x) => ({ id: x.nodeId, name: x.name }));
  mappedPath.unshift({ id: "", name: "", icon: "Home" });
  vm.selectedPath = mappedPath;
};
//#endregion

//#region LifeCycle
onMounted(() => {
  if (!props.value) {
    modals.open = true;
  } else {
    fetchAndSetPath(props.value);
  }
});
//#endregion

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "catalog-path-rule",
    onClick: _cache[2] || (_cache[2] = ($event: any) => (modals.open = true))
  }, [
    (_openBlock(), _createElementBlock("div", {
      class: "path-presenter-wrapper",
      key: localModel.value
    }, [
      _createVNode(PathPresenter, {
        modelValue: vm.selectedPath,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((vm.selectedPath) = $event))
      }, null, 8, ["modelValue"])
    ])),
    _createVNode(CatalogNodePathSelectionModal, {
      modelValue: modals.open,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((modals.open) = $event)),
      onConfirm: onConfirm,
      onHide: onHideHandler,
      "selected-entry-id": localModel.value,
      "selected-path": selectedPath.value
    }, null, 8, ["modelValue", "selected-entry-id", "selected-path"])
  ]))
}
}

})